import React from 'react';
import { useLocale } from '../../hooks/locale';
import { FacebookCircle, Instagram } from 'styled-icons/boxicons-logos';

import * as S from './styled';

const SocialLinks = () => {
  const { locale } = useLocale();
  const instagramUrl = `https://www.instagram.com/powwowclubbg/?hl=${locale}`;
  return (
    <S.SocialLinksList>
      <S.SocialLinksItem>
        <S.SocialLinksLink
          href="https://www.facebook.com/powwow.bg"
          title="Facebook"
          target="_blank"
          rel="noopener"
        >
          <FacebookCircle />
        </S.SocialLinksLink>
      </S.SocialLinksItem>
      <S.SocialLinksItem>
        <S.SocialLinksLink
          href={instagramUrl}
          title="Instagram"
          target="_blank"
          rel="noopener"
        >
          <Instagram />
        </S.SocialLinksLink>
      </S.SocialLinksItem>
    </S.SocialLinksList>
  );
};

export default SocialLinks;
